<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    label: string;
    icon?: string;
    iconRight?: string;
    fontSize?: string;
    removeExtraPadding?: boolean;
    borderRadius?: string;
    redIndicatorLocation?: 'left' | 'right' | 'none';
}>();

const bindableFontSize = props.fontSize ? `${props.fontSize}` : '14px';
const bindableBorderRadius = props.borderRadius ? `${props.borderRadius}` : '4px';
const computedRedIndicatorClass = computed(() => {
    switch (props.redIndicatorLocation) {
    case 'none':
        return '';
    case 'left':
        return 'red-indicator-left';
    default:
        return 'red-indicator-right';
    }
});
</script>
<template>
    <q-item
        clickable
        tag="a"
        color="fsum-black"
        class="nav-btn"
        :class="{
            'q-my-md q-py-xs q-px-sm': !props.removeExtraPadding,
            [computedRedIndicatorClass]: true,
        }"
        active-class="selected-item bg-gray text-dark-gray"
        :aria-label="label"
        role="button"
    >
        <q-item-section
            v-if="icon"
            avatar
        >
            <q-icon
                color="med-black"
                :name="icon"
            />
        </q-item-section>
        <q-item-section>
            {{ label }}
        </q-item-section>
        <q-item-section
            v-if="iconRight"
            avatar
        >
            <q-icon
                color="med-black"
                :name="iconRight"
            />
        </q-item-section>
    </q-item>
</template>
<style scoped lang="scss">
.nav-btn {
    border-radius: v-bind(bindableBorderRadius);
    font-size: v-bind(bindableFontSize);

    // Make room for the red indicator in order to prevent reflow issues
    &.red-indicator-left {
        border-left: 5px solid transparent;
    }

    &.selected-item {
        font-weight: 500;

        &.red-indicator-right {
            margin-right: -5px;
            border-right: 5px solid var(--fsum-red2);
        }

        &.red-indicator-left {
            border-left: 5px solid var(--fsum-red2);
        }
    }
    :deep(.q-item__section--avatar) {
        min-width: auto;
    }
}
</style>
